/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { isEmpty } from 'lodash';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { isContained } from '@ithinkdt/shared/utils';
import { MenuData } from '@ithinkdt/theme/models';

import { MenuService } from '../../menu.service';

/***
 * åèç¹èåç»ä»¶
 * åä¸ºä¸ç§ï¼
 *
 * 1ï¼ ç±»åä¸ï¼ å·¦ä¾§èåï¼æªæ¶ç¼©ï¼è§¦åï¼ åå»
 * 2ï¼ ç±»åäºï¼ å·¦ä¾§èåï¼æ¶ç¼©ï¼è§¦åï¼ é¼ æ ç§»å¥ç§»åº
 * 3ï¼ ç±»åä¸ï¼ å¤´é¨èåï¼è§¦åï¼ é¼ æ ç§»å¥ç§»åº
 *
 * */
@Component({
  selector: 'dt-single-menu-node',
  templateUrl: './single-menu-node.component.html',
  styleUrls: ['./single-menu-node.component.scss'],
})
export class SingleMenuNodeComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  // æ¯å¦æ¾ç¤ºå­èç¹
  showChildren = false;
  // éä¸­çèåèç¹ï¼ç±»å1ç¬æï¼
  selectedNode: any = {};
  bodyRef: Body;
  qLi: HTMLLIElement;
  subscribeScoll: any;
  isEn = false;

  set$: Subscription;
  scroll$: Subscription;
  i18n$: Subscription;

  @Input() collapsed: boolean;
  @Input() topMenu: boolean;
  @Input() data: any;

  @ViewChild('absoluteLiLeft', { static: false })
  absoluteLiLeft: ElementRef;

  @ViewChild('absoluteLiTop', { static: false })
  absoluteLiTop: ElementRef;

  constructor(
    @Inject(DOCUMENT) private doc: any,
    private el: ElementRef,
    private zone: NgZone,
    private settings: SettingsService,
    private menuService: MenuService,
    private i18NSrv: I18NService
  ) {
    this.addSubs();
    this.setDefaultLang();
  }

  ngOnChanges() {
    // åæ¢è³ç±»åäºæ¶éç½®èåæ ·å¼ï¼ä¸ç¶ä¼é»è®¤æ¾ç¤ºä¹åå±å¼çå­èå
    if (!this.topMenu && this.collapsed) {
      this.showChildren = false;
    }
  }

  ngOnInit() {
    // ç±»åä¸
    if (!this.topMenu && !this.collapsed) {
      this.updateMenu(this.settings.selectedMenu);
    }
  }

  ngAfterViewInit() {
    // console.log("getElementViewLeft", this.absoluteLiLeft)
    // this.bodyRef = this.doc.body;
    // console.log("getElementViewLeft", this.absoluteLiLeft.nativeElement)
    // this.scroll$ = fromEvent(window, 'resize').pipe(
    //   debounceTime(1500)
    // ).subscribe((event) => {
    //    this.onWindowScroll(event);
    // });
    // this.qLi = (this.el.nativeElement as HTMLLIElement).querySelector(
    //   '.ant-input',
    // ) as HTMLLIElement;
    // if (this.absoluteLiLeft) {
    //   console.log(
    //     "this.absoluteLiLeft",
    //     this.absoluteLiLeft.nativeElement.clientWidth
    //   );
    // }
    // if (this.absoluteLiTop) {
    //   console.log(
    //     "åªä¸ªåç´ ",
    //     this.absoluteLiTop.nativeElement,
    //     "this.absoluteLiTop",
    //     this.absoluteLiTop.nativeElement.getBoundingClientRect().right
    //     // this.getElementViewLeft(this.absoluteLiTop.nativeElement),
    //   );
  }

  ngOnDestroy(): void {
    this.set$.unsubscribe();
    this.scroll$.unsubscribe();
    this.i18n$.unsubscribe();
  }

  addSubs() {
    // éä¸­èç¹æ°æ®ççå¬
    this.set$ = this.menuService.selectedNode$.subscribe((data) => {
      this.selectedNode = data.node;
      this.updateMenu(data.node, data.bool);
    });

    this.zone.runOutsideAngular(() => {
      this.scroll$ = fromEvent(window, 'resize')
        .pipe(
          debounceTime(1500),
          distinctUntilChanged()
        )
        .subscribe((event) => {
          this.zone.run(() => {
            this.onWindowScroll(event);
          });
        });
    });
    this.i18n$ = this.i18NSrv.change.subscribe((evt) => {
      this.setLangType(evt);
    });
  }

  setDefaultLang() {
    this.setLangType(this.i18NSrv.storedLang());
  }

  setLangType(evt) {
    if (evt === 'en') {
      this.isEn = true;
    } else {
      this.isEn = false;
    }
  }

  onWindowScroll(event) {
    // console.log("event", event);
    // this.addListenerService.throttlea(500, 500)
    // console.log(
    //   "åªä¸ªåç´ ",
    //   this.absoluteLiTop.nativeElement,
    //   "this.absoluteLiTop",
    //   this.absoluteLiTop.nativeElement.getBoundingClientRect().right
    //   // this.getElementViewLeft(this.absoluteLiTop.nativeElement),
    // );
  }

  // getElementViewLeft(element) {
  //   let actualRight = element.offsetRight;
  //   let current = element.offsetParent;

  //   while (current !== null) {
  //     actualRight += current.offsetLeft;
  //     current = current.offsetParent;
  //   }

  //   let elementScrollLeft;
  //   if (document.compatMode === 'BackCompat') {
  //     elementScrollLeft = document.body.scrollLeft;
  //   } else {
  //     elementScrollLeft = document.documentElement.scrollLeft;
  //   }

  //   return actualRight - elementScrollLeft;
  // }

  // getElementViewTop(element) {
  //   let actualTop = element.offsetTop;
  //   let current = element.offsetParent;

  //   while (current !== null) {
  //     actualTop += current.offsetTop;
  //     current = current.offsetParent;
  //   }
  //   const elementScrollTop;
  //   if (document.compatMode === 'BackCompat') {
  //     elementScrollTop = document.body.scrollTop;
  //   } else {
  //     elementScrollTop = document.documentElement.scrollTop;
  //   }

  //   return actualTop - elementScrollTop;
  // }

  updateMenu(node, bool?) {
    // é¦åå¤æ­æ¯å¦ä¸ä¸ªç³»å
    // [1,2,3] ==> [1], [1,2], [1,2,3]
    // [1,2,4] ==> [1], [1,2], [1,2,4]
    if (bool || isEmpty(node)) {
      this.showChildren = false;
      return;
    }

    if (isContained(node.ids, this.data.ids)) {
      if (node.moduleId === this.data.moduleId) {
        this.showChildren = !this.showChildren;
        return;
      }
      this.showChildren = true;
    } else {
      this.showChildren = false;
    }
  }

  /**
   * ç¹å»
   */
  itemClicked(event, item: MenuData) {
    event.stopPropagation();
    // ç¼å­èç¹æ°æ®ï¼å·æ°é¡µé¢è¿åï¼
    this.settings.setSelectedMenu(item);
    // éä¸­èç¹æ°æ®æ¨é
    this.menuService.setSelected(item);
  }

  /**
   * hover
   */
  itemHover(event, item: MenuData) {
    event.stopPropagation();
    this.menuService.setSelected(item);
  }

  /**
   * hoveræ¶ç¹å»å³å³é­
   */
  closeNodes() {
    this.menuService.setSelected({}, true);
  }

  // è®¡ç®ç¼©è¿å¤å°
  calculateIndent(level) {
    return {
      'padding-left': level * 24 + 'px',
    };
  }

  // å¤æ­æ¯åªä¸ªå¾æ åºï¼ æ`fa-`çåæ¯font-awesomeï¼æ²¡æåæ¯ng-zorro
  judgeIconLib(icon: string) {
    if (!icon) {
      return true;
    }
    const isFontAwesome = /fa-/.test(icon);
    return isFontAwesome ? true : false;
  }
}
